export const ROLE_SUPER_ADMIN = 'superadmin';
export const ROLE_OPERATOR = 'operator';
export const ROLE_CANDIDATE = 'candidate';
export const ROLE_CURATOR = 'curator';